<template>
    <div style="overflow:hidden;position: relative" :ref="'fileinfo'">
        <div class="flex flex-row" ref="infoflex">
            <div class="flex-0 m-3" style="width: 250px; min-width: 250px; overflow: visible;" ref="infobox">
                <div class="flex items-start mb-6">
                    <div class="mr-2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="19px" height="19px" viewBox="0 0 24 24"
                             fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                             stroke-linejoin="round" class="text-theme vue-feather feather feather-folder">
                            <path
                                d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
                        </svg>
                    </div>
                    <div>
                        <b class="block overflow-hidden text-ellipsis text-sm">
                            {{ directory.name }}
                        </b>
                        <small class="block text-xs text-gray-400">
                        </small>
                    </div>
                </div>
                <div class="mb-3">
                    <small class="text-theme block text-xs">
                        Created at
                    </small>
                    <b class="inline-block text-sm">
                        {{ directory.createdAt.format('MMMM Do YYYY, h:mm:ss a') }}
                    </b>
                </div>
                <div class="mb-3">
                    <small class="text-theme block text-xs">
                        Created by
                    </small>
                    <b class="inline-block text-sm">
                        {{ directory.createdBy }}
                    </b>
                </div>
                <div class="mb-3" v-if="directory.lastUpdatedAt">
                    <small class="text-theme block text-xs">
                        Last updated at
                    </small>
                    <b class="inline-block text-sm">
                        {{ directory.lastUpdatedAt.format('MMMM Do YYYY, h:mm:ss a') }}
                    </b>
                </div>
                <div class="mb-3" v-if="directory.lastUpdatedAt">
                    <small class="text-theme block text-xs">
                        Last updated by
                    </small>
                    <b class="inline-block text-sm">
                        {{ directory.lastUpdatedBy }}
                    </b>
                </div>
                <div class="mb-3">
                    <small class="text-theme block text-xs">
                        System Directory
                    </small>
                    <b class="inline-block text-sm">
                        {{ directory.system ? 'Yes' : 'No' }}
                    </b>
                </div>

                <div class="mb-3">
                    <small class="text-theme block text-xs">
                        Location
                    </small>
                    <div class="items-center">
                        <template v-for="(loc,index) in this.locations()">
                            <span v-if="loc" class="">&gt;</span>
                            <b v-if="loc && !loc.isRoot"
                               class="cursor-pointer inline-block whitespace-nowrap text-sm hover:text-blue-500 hover:bg-gray-100 rounded border-2 border-none px-1 -ml-1"
                               v-text="loc.name"
                               @click="navigateTo(loc)">
                            </b>
                            <b class="cursor-pointer inline-block whitespace-nowrap text-sm hover:text-blue-500 hover:bg-gray-100 rounded border-2 border-none px-1 -ml-1"
                               v-else @click="navigateTo(null)"><span class='fas fa-home text-sm'
                                                                      style='margin-top:4px;margin-bottom:4px;'></span></b>
                        </template>
                    </div>
                </div>

                <div class="mb-3" v-if="directory.tags.length">
                    <small class="text-theme block text-xs">
                        Tags
                    </small>
                    <div v-for="(tag, index) in directory.tags" class="flex">
                        <div class="w-4 h-4 rounded-full flex-0 mt-1 mr-1"
                             :style="'background-color: '+(getFsTag(tag)?getFsTag(tag).colorHex:'#FFF')">
                        </div>
                        <span class="flex-1 block overflow-hidden whitespace-nowrap text-s text-ellipsis">
                    {{ tag }}
                </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        filesystem: Object,
        directory: Object
    },
    data() {
        return {}
    },
    computed: {},
    methods: {
        getFsTag(tag) {
            return this.filesystem.tags.find((t) => t.name === tag)
        },
        locations() {
            let pName = (p) => {
                if (p.parent) {
                    let ret = pName(p.parent)
                    ret.push(p);
                    return ret;
                } else {
                    return [null]
                }
            }
            const parts = pName(this.directory);
            parts.pop();
            return parts;
        },
        navigateTo(destination) {
            this.$emit('navigateTo', destination)
        }
    },
    mounted() {
    }
}
</script>

